import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";
import { APP_CHAT_LEADS_ROUTE } from "./chatLeads.path";

const ChatLeads = Loadable(
  lazy(() =>
    import("./Chatleads").then(({ ChatLeads }) => ({
      default: ChatLeads,
    }))
  )
);

export const chatLeadRoutes = [
  {
    path: APP_CHAT_LEADS_ROUTE,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleIds={[]}>
        <ChatLeads />
      </AuthorizedRoute>
    ),
  },
];
